import gql from 'graphql-tag'

export const paymentIntentForOrder = gql`
  mutation PaymentIntent($order: OrderInput!) {
    paymentIntentForOrder(order: $order)
  }
`
